// extracted by mini-css-extract-plugin
module.exports =  {"mediumIllustration":"IconDefault-module__mediumIllustration____oJ7t"};